import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  FaArrowCircleLeft,
  FaHeart,
  FaRegHeart,
  FaSave,
  FaTimes,
  FaSearch,
  FaPlus,
  FaLayerGroup,
} from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { toast } from "react-toastify";
import "./ProjectHeader.css";
import { FiEdit } from "react-icons/fi";

const ProjectHeader = ({
  // Project Data
  project,
  originalProject,

  // Edit State
  isEditing,
  saving,

  // Permissions
  hasEditPermission,

  // Handlers
  handleFieldChange,
  handleSave,
  handleCancel,
  handleToggleFavorite,
  setIsEditing,

  // Navigation
  navigate,
}) => {
  const [isHovering, setIsHovering] = useState(false);

  // Get project initials for avatar
  const getProjectInitials = () => {
    if (!project?.prTitle) return "P";
    return project.prTitle
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="ph-project-header">
      {/* Top Navigation Bar */}
      <div className="ph-top-nav">
        <div style={{ display: "flex", flexDirection: "row" }}>
          {/* <button
            className="ph-back-btn"
            onClick={() => navigate("/viewProjects")}
            title="Back to Projects"
          >
            <FaArrowCircleLeft />
          </button> */}
          {/* Quick Search */}
          <div className="ph-quick-search">
            <FaSearch className="ph-search-icon" />
            <input
              type="text"
              placeholder="Quick search..."
              className="ph-search-input"
            />
          </div>
        </div>

        <div className="ph-header-actions">
          {/* Add Task Button */}
          <button className="ph-add-task-btn">
            <FaPlus />
            <span>Add Task</span>
          </button>

          {/* Favorite Button */}
          <button
            className={`ph-favorite-btn ${project?.isFavourite ? "active" : ""}`}
            onClick={handleToggleFavorite}
            title={
              project?.isFavourite
                ? "Remove from favorites"
                : "Add to favorites"
            }
          >
            {project?.isFavourite ? <FaHeart /> : <FaRegHeart />}
          </button>

          {/* Edit/Save/Cancel Buttons */}
          {hasEditPermission() && (
            <>
              {isEditing ? (
                <div className="ph-edit-actions">
                  <button
                    className="ph-save-btn"
                    onClick={handleSave}
                    disabled={saving}
                  >
                    <FaSave />
                    <span>{saving ? "Saving..." : "Save"}</span>
                  </button>
                  <button
                    className="ph-cancel-btn"
                    onClick={handleCancel}
                    disabled={saving}
                  >
                    <FaTimes />
                    <span>Cancel</span>
                  </button>
                </div>
              ) : (
                <button
                  className="ph-edit-btn"
                  onClick={() => setIsEditing(true)}
                >
                  <FiEdit />
                  <span>Edit</span>
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {/* Project Hero Section */}
      <div className="ph-hero-section">
        {/* <div className="ph-project-avatar">
          <span>{getProjectInitials()}</span>
        </div> */}
        <div className="ph-project-indicator"></div>

        <div className="ph-project-info">
          {hasEditPermission() && isEditing ? (
            <Form.Control
              type="text"
              value={project?.prTitle || ""}
              onChange={(e) => handleFieldChange("prTitle", e.target.value)}
              className="ph-title-input"
              placeholder="Project Title"
            />
          ) : (
            <h1
              className="ph-project-title"
              onMouseEnter={() => hasEditPermission() && setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
              onClick={() => hasEditPermission() && setIsEditing(true)}
            >
              {project?.prTitle}
              {hasEditPermission() && isHovering && !isEditing && (
                <span className="ph-edit-hint">
                  <i className="fas fa-pen"></i> Click to edit
                </span>
              )}
            </h1>
          )}

          <div className="ph-project-meta">
            <span className="ph-project-id">
              {/* <i className="fas fa-hashtag"></i> */}
              {project?.projectId}
            </span>
            <span className="ph-meta-divider">•</span>
            {/* <span className="ph-project-status">
              <span
                className={`ph-status-dot ${project?.projectStatus === "Completed" ? "completed" : "active"}`}
              ></span>
              {project?.projectStatus || "Active"}
            </span> */}
            {/* <span className="ph-meta-divider">•</span> */}
            {/* <span className="ph-monitoring-badge">
              <FaLayerGroup className="ph-monitoring-icon" />
              MONITORING 24 ACTIVE HIGH-PRIORITY DELIVERABLES
            </span> */}
            <p className="ph-project-subtitle">
              {project?.prDescription ||
                "Managing project tasks and deliverables"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectHeader;
